import { Embeddings } from "@langchain/core/embeddings";
import axios from 'axios';

// Get Supabase function URL from environment with hardcoded fallbacks
const EMBEDDINGS_FUNCTION_URL = process.env.REACT_APP_SUPABASE_FUNCTION_EMBEDDINGS || 
  'https://fgovywiapnpjgqoviicz.supabase.co/functions/v1/embeddings';
const SUPABASE_ANON_KEY = process.env.REACT_APP_SUPABASE_ANON_KEY || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImZnb3Z5d2lhcG5wamdxb3ZpaWN6Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDI3OTI4MjgsImV4cCI6MjA1ODM2ODgyOH0.uRxpNAgcjLQGUL1Oq23QfFniPMHtfLX_6cIha4DHUa0';

export class EnhancedOpenAIEmbeddings extends Embeddings {
  constructor() {
    super({});
  }

  async embedDocuments(texts: string[]): Promise<number[][]> {
    try {
      const response = await axios.post(EMBEDDINGS_FUNCTION_URL, {
        input: texts,
        model: "text-embedding-ada-002"
      }, {
        headers: {
          'Content-Type': 'application/json',
          'apikey': SUPABASE_ANON_KEY
        }
      });

      // OpenAI returns embeddings in response.data.data array
      return response.data.data.map((item: any) => item.embedding);
    } catch (error) {
      console.error('Error calling embeddings function:', error);
      throw error;
    }
  }

  async embedQuery(text: string): Promise<number[]> {
    try {
      const response = await axios.post(EMBEDDINGS_FUNCTION_URL, {
        input: text,
        model: "text-embedding-ada-002"
      }, {
        headers: {
          'Content-Type': 'application/json',
          'apikey': SUPABASE_ANON_KEY
        }
      });

      // OpenAI returns embedding in response.data.data[0].embedding
      return response.data.data[0].embedding;
    } catch (error) {
      console.error('Error calling embeddings function:', error);
      throw error;
    }
  }
} 